<template>
  <div class="corporate-training-page">
    <div class="hero-section">
      <div class="container">
        <div class="row centered">
          <div class="head">
            <h1>
              Tailored <span class="highlight">Corporate Training</span>
              for <span class="highlight-2">Lasting Business Success</span>
            </h1>
            <p>
              Custom data and AI learning program tailored to your company’s needs and skill gaps.
            </p>
            <div class="wrapper">
              <a
                :href="'https://calendly.com/365datascience'" target="_blank" data-event="hero_button.click"
                class="btn-primary"
              >
                Schedule a Call
              </a>
              <a class="reviews-wrapper" href="/reviews/" target="_blank">
                <img class="users" src="../assets/images/corporate-training/users-group.png" alt="users">
                <img class="users hover" src="../assets/images/corporate-training/users-group-hovered.png" alt="users">
                <span>Trusted by 3M</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="logo-wrapper">
        <p class="container">
          Trusted by learners from top-tier companies
        </p>
        <SlidingAnimation class="companies-animation" horizontal>
          <div class="row">
            <IconGoogle />
            <IconMeta />
            <IconApple />
            <IconMicrosoft />
            <IconIkea />
            <IconDeloitte />
            <IconDell />
            <IconLindt />
            <IconUPS />
            <IconNissan />
            <IconVirginMedia />
            <IconBosch />
            <IconLeowe />
            <IconFedex />
            <IconVanguard />
            <IconWalmart />
            <IconStarbucks />
            <IconHumana />
            <IconGoogle />
            <IconMeta />
            <IconApple />
            <IconMicrosoft />
            <IconIkea />
            <IconDeloitte />
            <IconDell />
            <IconLindt />
            <IconUPS />
            <IconNissan />
            <IconVirginMedia />
            <IconBosch />
            <IconLeowe />
            <IconFedex />
            <IconVanguard />
            <IconWalmart />
            <IconStarbucks />
            <IconHumana />
          </div>
        </SlidingAnimation>
      </div>
    </div>
    <div class="section charts container">
      <h2>Business Success Starts with <span class="highlight-2 block">SKILLED EMPLOYEES</span></h2>
      <div class="row progress-holder">
        <div
          v-for="(chart, idx) in chartsData"
          :key="idx"
          class="col col-4"
        >
          <div class="progress">
            <div style="position: relative; width: 150px; height: 150px;">
              <svg
                v-if="chart.percent <= 100"
                class="progress-background"
                xmlns="http://www.w3.org/2000/svg" width="152" height="152"
                viewBox="0 0 152 152" fill="none"
              >
                <mask
                  id="path-1-outside-1_28823_168" maskUnits="userSpaceOnUse" x="0"
                  y="0" width="152" height="152"
                  fill="black"
                >
                  <rect fill="white" width="152" height="152" />
                  <path d="M146 76C146 114.66 114.66 146 76 146C37.3401 146 6 114.66 6 76C6 37.3401 37.3401 6 76 6C114.66 6 146 37.3401 146 76ZM13 76C13 110.794 41.2061 139 76 139C110.794 139 139 110.794 139 76C139 41.2061 110.794 13 76 13C41.2061 13 13 41.2061 13 76Z" />
                </mask>
                <path d="M146 76C146 114.66 114.66 146 76 146C37.3401 146 6 114.66 6 76C6 37.3401 37.3401 6 76 6C114.66 6 146 37.3401 146 76ZM13 76C13 110.794 41.2061 139 76 139C110.794 139 139 110.794 139 76C139 41.2061 110.794 13 76 13C41.2061 13 13 41.2061 13 76Z" fill="#545C69" />
                <path
                  d="M146 76C146 114.66 114.66 146 76 146C37.3401 146 6 114.66 6 76C6 37.3401 37.3401 6 76 6C114.66 6 146 37.3401 146 76ZM13 76C13 110.794 41.2061 139 76 139C110.794 139 139 110.794 139 76C139 41.2061 110.794 13 76 13C41.2061 13 13 41.2061 13 76Z" stroke="#293343" stroke-width="12"
                  mask="url(#path-1-outside-1_28823_168)"
                />
              </svg>
              <svg
                v-else
                class="progress-background"
                xmlns="http://www.w3.org/2000/svg" width="152" height="152"
                viewBox="0 0 152 152" fill="none"
              >
                <mask
                  id="path-1-outside-1_28823_179" maskUnits="userSpaceOnUse" x="0.197266"
                  y="0.197266" width="152" height="152"
                  fill="black"
                >
                  <rect
                    fill="white" x="0.197266" y="0.197266"
                    width="152" height="152"
                  />
                  <path d="M134.803 76C134.803 108.476 108.476 134.803 76 134.803C43.5241 134.803 17.1973 108.476 17.1973 76C17.1973 43.5241 43.5241 17.1973 76 17.1973C108.476 17.1973 134.803 43.5241 134.803 76ZM23.0775 76C23.0775 105.228 46.7717 128.922 76 128.922C105.228 128.922 128.922 105.228 128.922 76C128.922 46.7717 105.228 23.0775 76 23.0775C46.7717 23.0775 23.0775 46.7717 23.0775 76Z" />
                </mask>
                <path d="M134.803 76C134.803 108.476 108.476 134.803 76 134.803C43.5241 134.803 17.1973 108.476 17.1973 76C17.1973 43.5241 43.5241 17.1973 76 17.1973C108.476 17.1973 134.803 43.5241 134.803 76ZM23.0775 76C23.0775 105.228 46.7717 128.922 76 128.922C105.228 128.922 128.922 105.228 128.922 76C128.922 46.7717 105.228 23.0775 76 23.0775C46.7717 23.0775 23.0775 46.7717 23.0775 76Z" fill="#293343" />
                <path
                  d="M134.803 76C134.803 108.476 108.476 134.803 76 134.803C43.5241 134.803 17.1973 108.476 17.1973 76C17.1973 43.5241 43.5241 17.1973 76 17.1973C108.476 17.1973 134.803 43.5241 134.803 76ZM23.0775 76C23.0775 105.228 46.7717 128.922 76 128.922C105.228 128.922 128.922 105.228 128.922 76C128.922 46.7717 105.228 23.0775 76 23.0775C46.7717 23.0775 23.0775 46.7717 23.0775 76Z" stroke="#293343" stroke-width="34"
                  mask="url(#path-1-outside-1_28823_179)"
                />
              </svg>
              <svg
                v-if="chart.percent <= 100" class="progress-circle"
                width="150" height="150"
              >
                <circle
                  :id="`progressCircle${idx}`"
                  cx="74" cy="76" r="66"
                  :stroke="chart.color"
                  stroke-width="7"
                  fill="none"
                  stroke-linecap="round"
                  transform="rotate(-90 75 75)"
                  style="stroke-dasharray: 414.6902302738527; stroke-dashoffset: 414.6902302738527;"
                />
              </svg>
              <template v-else>
                <svg class="progress-circle hidden" width="150" height="150">
                  <circle
                    :id="`progressCircle${idx}0`"
                    cx="74" cy="76" r="68"
                    :stroke="chart.color"
                    stroke-width="7"
                    fill="none"
                    stroke-linecap="round"
                    transform="rotate(-90 75 75)"
                    style="stroke-dasharray: 427.257; stroke-dashoffset: 427.257;"
                  />
                </svg>
                <svg class="progress-circle" width="150" height="150">
                  <circle
                    :id="`progressCircle${idx}`"
                    cx="74" cy="76" r="68"
                    :stroke="chart.color"
                    stroke-width="7"
                    fill="none"
                    stroke-linecap="round"
                    transform="rotate(-90 75 75)"
                    style="stroke-dasharray: 427.257; stroke-dashoffset: 427.257;"
                  />
                </svg>
                <svg class="progress-circle" width="150" height="150">
                  <circle
                    :id="`progressCircle${idx}1`"
                    cx="74" cy="76" r="56"
                    :stroke="chart.color"
                    stroke-width="8"
                    fill="none"
                    stroke-linecap="round"
                    transform="rotate(-90 75 75)"
                    style="stroke-dasharray: 414.6902302738527; stroke-dashoffset: 414.6902302738527;"
                  />
                </svg>
                <svg class="progress-circle" width="150" height="150">
                  <circle
                    :id="`progressCircle${idx}2`"
                    cx="74" cy="76" r="44"
                    :stroke="chart.color"
                    stroke-width="8"
                    fill="none"
                    stroke-linecap="round"
                    transform="rotate(-90 75 75)"
                    style="stroke-dasharray: 414.6902302738527; stroke-dashoffset: 414.6902302738527;"
                  />
                </svg>
              </template>
              <div :id="`percentageText${idx}${idx === 1 ? '0' : ''}`" class="number" :style="{ color: chart.color }">
                0%
              </div>
            </div>
          </div>
          <div class="titles">
            <p class="title" v-html="chart.title" />
            <p class="chart-description" v-html="chart.description" />
          </div>
        </div>
      </div>
    </div>
    <div class="section container">
      <h2>How We Ensure Your Company’s <span class="highlight">Success</span></h2>
      <p class="description">
        Our unique <span class="highlight">ACT Method</span> guides your team through personalized, structured, and hands-on data and AI training, directly aligned with your company's objectives—without disrupting your business operations.
      </p>
      <div class="box-wrapper row">
        <img src="../assets/images/corporate-training/point-start.png" alt="act method" class="point-mobile">
        <div class="col col-4">
          <div class="box">
            <p> Week 1</p>
            <IconAssessment />
            <h3><span class="highlight">A</span>ssessment</h3>
            <p>We assess your company's needs, industry specifics, and employee skill gaps and level.</p>
          </div>
        </div>
        <img src="../assets/images/corporate-training/point-middle.png" alt="act method" class="point-mobile">
        <div class="col col-4">
          <div class="box">
            <p> Week 2</p>
            <IconCustomization />
            <h3><span class="highlight">C</span>ustomization</h3>
            <p>We craft fully customized learning plans for each employee and a curriculum with experts in your target upskilling areas.</p>
          </div>
        </div>
        <img src="../assets/images/corporate-training/point-middle.png" alt="act method" class="point-mobile">
        <div class="col col-4">
          <div class="box">
            <p> Week 3-14</p>
            <IconTraining />
            <h3><span class="highlight">T</span>raining</h3>
            <p>Employees actively engage in personalized live workshops, self-paced learning, and hands-on projects, integrating studying into their daily responsibilities without disrupting your business operations.</p>
          </div>
        </div>
        <img src="../assets/images/corporate-training/point-start.png" alt="act method" class="point-mobile end">
      </div>
      <div class="holder">
        <img src="../assets/images/corporate-training/points-with-lines.png" alt="points" class="points">
        <IconGraduation class="icon-graduation" />
        <h3>Graduation</h3>
        <p class="description">
          Your team is fully equipped and ready to effectively implement their enhanced data and AI skills, driving immediate and sustainable results for your business.
        </p>
        <a
          :href="'https://calendly.com/365datascience'" target="_blank" data-event="graduation_button.click"
          class="btn-primary"
        >
          Schedule a Call
        </a>
      </div>
    </div>
    <div class="section reviews container">
      <div class="row">
        <div class="first-container col col-7">
          <h3>Proven Impact. <span class="highlight-2">Real</span> Results</h3>
          <SliderInfinite
            align="left" :auto-run="6" dots
            :unique-ids="['yuvraj-shivaji-dhepe', 'lee-mcfarling', 'veronika-konecna']"
            heading="h2" heading-class="section-title"
          >
            <div
              v-for="(testimonial, idx) in testimonials" :key="idx" slot="slide"
              class="box" :data-uid="testimonial.uniqueId"
            >
              <IconQuote class="quote" />
              <p class="review-description" v-html="testimonial.description" />
              <div class="people">
                <img :src="require(`../assets/images/corporate-training/testimonial-${testimonial.image}.webp`)" :alt="testimonial.name" class="person">
                <div class="text">
                  <p class="name">
                    {{ testimonial.name }}
                  </p>
                  <p class="work">
                    {{ testimonial.work }} <component :is="require(`../assets/svg/corporate-training/icon-${testimonial.logo}.svg?vue-component`)" />
                  </p>
                </div>
              </div>
            </div>
          </SliderInfinite>
        </div>
        <div class="second-container col col-5">
          <div class="wrapper">
            <div class="holder">
              <p class="number">
                3M+
              </p>
              <p class="students">
                Students
              </p>
              <a
                href="https://www.trustpilot.com/review/365datascience.com" target="_blank" class="no-hover"
                data-event="trustpilot_button.click"
              >
                <p class="number">
                  4.9
                </p>
                <IconStars class="stars" />
                <div class="trust-wrap">
                  <IconTrustpilot class="trustpilot" /> <span>Based on <span class="highlight-2">804 reviews</span></span>
                </div>
              </a>
              <p class="number">
                96%
              </p>
              <p class="small-text">
                of learners recommend 365 Data Science
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section medals container">
      <span class="gradient-line first" />
      <div class="image-holder">
        <img src="../assets/images/corporate-training/elqn.webp" alt="elqn" class="elqn-medal">
        <img src="../assets/images/corporate-training/aehea.webp" alt="aehea" class="aehea-medal">
        <img src="../assets/images/corporate-training/adasci.webp" alt="adasci" class="adasci-medal">
        <img src="../assets/images/corporate-training/gaote.webp" alt="gaote" class="gaote-medal">
      </div>
      <span class="gradient-line" />
    </div>
    <div class="section tailored-for-you container">
      <h2>Tailored for <span class="highlight">YOU</span>. Built for <span class="highlight">SUCCESS</span>.</h2>
      <h3>Corporate Training for Long-Lasting Results</h3>
      <div class="wrapper row">
        <div class="box col col-4">
          <IconOnboardingCall />
          <p class="title">
            Onboarding Call
          </p>
          <p class="small-description">
            Clearly define your objectives and ensure alignment from the start.
          </p>
        </div>
        <div class="box col col-4">
          <IconComprehensiveCompany />
          <p class="title">
            Comprehensive Company Assessment
          </p>
          <p class="small-description">
            Discover employee skill levels and identify strategic training areas.
          </p>
        </div>
        <div class="box col col-4">
          <IconCustomizedPlan />
          <p class="title">
            Customized Learning Plan
          </p>
          <p class="small-description">
            Personalized data and AI training to meet unique employee roles and business goals.
          </p>
        </div>
        <div class="box col col-4">
          <IconCoaching />
          <p class="title">
            1:1 Coaching & Instructor Sessions
          </p>
          <p class="small-description">
            Gain individualized insights, immediate feedback, and deepened understanding.
          </p>
        </div>
        <div class="box col col-4">
          <IconWorkshops />
          <p class="title">
            Company-Specific Workshops
          </p>
          <p class="small-description">
            Interactive, practical workshops addressing your specific business challenges.
          </p>
        </div>
        <div class="box col col-4">
          <IconIndustryContent />
          <p class="title">
            Industry-Relevant Content
          </p>
          <p class="small-description">
            Training materials and exercises directly related to your industry’s dynamics.
          </p>
        </div>
      </div>
    </div>
    <div class="section instructors">
      <div class="instructors-slider">
        <div class="heading">
          <h2>
            Unlock Your Team’s Potential with <span class="highlight-2">Best-in-Class</span> Instructors
          </h2>
          <p class="description">
            We bring the industry’s top instructors—renowned experts in AI, data science, and engineering—to deliver high-impact corporate training. Our live, interactive program goes beyond generic content, delivering real-world skills from professionals driving innovation in the field.
          </p>
        </div>
        <SlidingAnimation class="instructors-animation" horizontal duration-h="60s">
          <div>
            <div v-for="counter in 2" :key="counter">
              <div
                v-for="(instructor, idx) in instructors"
                :key="`${idx}${instructor.slug}`"
              >
                <a :href="`/instructors/${instructor.slug}`" target="_blank">
                  <img :src="require(`../assets/images/corporate-training/instructor-${instructor.image || instructor.slug}.webp`)" :alt="instructor.name" class="instructor-desktop">
                  <img :src="require(`../assets/images/corporate-training/instructor-${instructor.image || instructor.slug}-mobile.webp`)" :alt="instructor.name" class="instructor-mobile">
                </a>
              </div>
            </div>
          </div>
        </SlidingAnimation>
      </div>
    </div>
    <div class="section table">
      <div class="container heading">
        <h2 class="section-title">
          Transparent and <span class="highlight yellow">FLEXIBLE</span> Pricing for Every Team
        </h2>
        <div class="table-wrapper">
          <div id="compare-features" class="features">
            <div class="content">
              <div class="row sticky" :class="{ scrolled: tableIsScrolled }">
                <div class="col col-3 features-title" />
                <div class="col col-3 quick-win">
                  <div class="col-bg">
                    <div class="title">
                      Quick Win
                    </div>
                    <div class="price">
                      <span class="discount-price">
                        $5,000
                      </span>
                    </div>
                    <a
                      href="https://calendly.com/365datascience" target="_blank" class="btn-primary btn-hollow"
                      data-event="table_quick_win.click"
                    >
                      Schedule a Call
                    </a>
                  </div>
                </div>
                <div class="col col-3 sustainable-growth">
                  <div class="col-bg">
                    <div class="title">
                      Sustainable Growth
                    </div>
                    <div class="price">
                      <span class="discount-price">
                        $30,000
                      </span>
                    </div>
                    <a
                      href="https://calendly.com/365datascience" target="_blank" class="btn-primary btn-clone"
                      data-event="table_sustainable_growth.click"
                    >
                      Schedule a Call
                    </a>
                  </div>
                </div>
                <div class="col col-3 enterprise-custom">
                  <div class="col-bg">
                    <div class="title">
                      Enterprise Custom
                    </div>
                    <div class="price">
                      <span class="discount-price">
                        Request a Quote
                      </span>
                    </div>
                    <a
                      href="https://calendly.com/365datascience" target="_blank" class="btn-primary btn-hollow btn-clone"
                      data-event="table_enterprise_custom.click"
                    >
                      Schedule a Call
                    </a>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ scrolled: tableIsScrolled }">
                <div class="col col-3 features-title">
                  Features
                </div>
                <div class="col col-3 quick-win">
                  <div class="col-bg">
                    <div class="title">
                      Quick Win
                    </div>
                    <div class="price">
                      <span class="discount-price">
                        $5,000
                      </span>
                      <span class="seats">
                        for 10 seats
                      </span>
                    </div>
                    <span class="billed">
                      2 Weeks
                    </span>
                    <a
                      href="https://calendly.com/365datascience" target="_blank" class="btn-primary btn-hollow"
                      data-event="table_quick_win.click"
                    >
                      Schedule a Call
                    </a>
                    <div v-show="$store.state.layout === 'mobile'" class="specs-mobile" :class="{ expanded: planSpecsMobile.expanded.quickWin }">
                      <span class="button-expand" @click="toggleSpecs('quickWin')">
                        See Details <IconArrow />
                      </span>
                      <div class="specs-mobile-holder">
                        <div class="specs-mobile-group">
                          Features
                        </div>
                        <div class="specs-mobile-spec first">
                          1 course
                          <Dropdown
                            :selected="`${selectedCourse}`"
                            :radio-buttons="courses"
                            @change="handleCourseChange"
                          />
                        </div>
                        <div
                          v-for="(spec, idx) in planSpecsMobile.quickWin" :key="`mobileSpecs${idx}`"
                          :class="[`specs-mobile-${spec.group ? 'group' : 'spec'}`]"
                        >
                          <IconCheck v-if="!spec.group" />
                          <span v-html="spec.name" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-3 sustainable-growth">
                  <div class="col-bg">
                    <div class="title">
                      Sustainable Growth
                    </div>
                    <div class="price">
                      <span class="discount-price">
                        $30,000
                      </span>
                      <span class="seats">
                        for 3 seats
                      </span>
                    </div>
                    <span class="billed">
                      12 Weeks
                    </span>
                    <a
                      href="https://calendly.com/365datascience" target="_blank" class="btn-primary btn-clone"
                      data-event="table_sustainable_growth.click"
                    >
                      Schedule a Call
                    </a>
                    <div v-show="$store.state.layout === 'mobile'" class="specs-mobile" :class="{ expanded: planSpecsMobile.expanded.sustainableGrowth }">
                      <span class="button-expand" @click="toggleSpecs('sustainableGrowth')">
                        See Details <IconArrow />
                      </span>
                      <div class="specs-mobile-holder">
                        <div class="specs-mobile-group">
                          Features
                        </div>
                        <div class="specs-mobile-spec first">
                          1 specialization (8+ courses)
                          <Dropdown
                            :selected="`${selectedTrack}`"
                            :radio-buttons="tracks"
                            @change="handleTrackChange"
                          />
                        </div>
                        <div
                          v-for="(spec, idx) in planSpecsMobile.sustainableGrowth" :key="`mobileSpecs${idx}`"
                          :class="[`specs-mobile-${spec.group ? 'group' : 'spec'}`]"
                        >
                          <IconCheck v-if="!spec.group" />
                          <span v-html="spec.name" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="label">
                    MOST IMPACTFUL
                  </span>
                </div>
                <div class="col col-3 enterprise-custom">
                  <div class="col-bg">
                    <div class="title">
                      Enterprise Custom
                    </div>
                    <div class="price">
                      <span class="discount-price">
                        Request a Quote
                      </span>
                    </div>
                    <span class="billed">
                      &nbsp;
                    </span>
                    <span v-show="$store.state.layout === 'mobile'" class="mobile-text">
                      Custom program for your entire team based on your needs and industry trends.
                    </span>
                    <a
                      href="https://calendly.com/365datascience" target="_blank" class="btn-primary btn-hollow btn-clone"
                      data-event="table_enterprise_custom.click"
                    >
                      Schedule a Call
                    </a>
                  </div>
                </div>
              </div>
              <div class="row row-selector">
                <div class="col col-3 blue">
                  Content
                </div>
                <div class="col col-3">
                  <div class="col-bg content-selector">
                    1 course
                    <Dropdown
                      :selected="`${selectedCourse}`"
                      :radio-buttons="courses"
                      @change="handleCourseChange"
                    />
                  </div>
                </div>
                <div class="col col-3">
                  <div class="col-bg content-selector">
                    <span>
                      1 specialization (8+ courses)
                    </span>
                    <Dropdown
                      :selected="`${selectedTrack}`"
                      :radio-buttons="tracks"
                      @change="handleTrackChange"
                    />
                  </div>
                </div>
                <div class="col col-3">
                  <div class="col-bg content-selector">
                    Custom program for your entire team based on your needs and industry trends.
                  </div>
                </div>
              </div>
              <div
                v-for="(spec, idx) in planSpecsMixed" :key="idx" class="row"
                :class="spec.class || 'spec'"
              >
                <div
                  v-for="(col, idx2) in spec.cols" :key="idx2" class="col col-3"
                  :class="{ check: col.check }"
                >
                  <div class="col-bg">
                    <IconCheck v-if="col.check" />
                    <IconCross v-else-if="col.check === false" />
                    <span v-else v-html="col.name || '&nbsp;'" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section banner container">
      <div class="banner-holder">
        <h2>Ready to <span class="highlight-2">Elevate</span> Your Team's Skills?</h2>
        <p class="description">
          Empower your workforce with training customized for your business. Boost employee performance, close critical skill gaps, and deliver measurable results.
        </p>
        <a
          href="https://calendly.com/365datascience" target="_blank" data-event="pre_footer_button.click"
          class="btn-primary"
        >
          Book Your Free Consultation
        </a>
      </div>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <script v-html="pixelScript"></script>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import SliderInfinite from '@itbpbg/lms-components/src/components/SliderInfinite';
import SlidingAnimation from '@itbpbg/lms-components/src/Animations/Sliding.vue';
import IconApple from '@itbpbg/lms-components/src/assets/svg/companies/icon-apple-auto.svg?vue-component';
import IconBosch from '@itbpbg/lms-components/src/assets/svg/companies/icon-bosch-auto.svg?vue-component';
import IconDell from '@itbpbg/lms-components/src/assets/svg/companies/icon-dell-auto.svg?vue-component';
import IconDeloitte from '@itbpbg/lms-components/src/assets/svg/companies/icon-deloitte-auto.svg?vue-component';
import IconFedex from '@itbpbg/lms-components/src/assets/svg/companies/icon-fedex-auto.svg?vue-component';
import IconGoogle from '@itbpbg/lms-components/src/assets/svg/companies/icon-google-auto.svg?vue-component';
import IconHumana from '@itbpbg/lms-components/src/assets/svg/companies/icon-humana-auto.svg?vue-component';
import IconIkea from '@itbpbg/lms-components/src/assets/svg/companies/icon-ikea-auto.svg?vue-component';
import IconLeowe from '@itbpbg/lms-components/src/assets/svg/companies/icon-leowe-auto.svg?vue-component';
import IconLindt from '@itbpbg/lms-components/src/assets/svg/companies/icon-lindt-auto.svg?vue-component';
import IconMeta from '@itbpbg/lms-components/src/assets/svg/companies/icon-meta-auto.svg?vue-component';
import IconMicrosoft from '@itbpbg/lms-components/src/assets/svg/companies/icon-microsoft-auto.svg?vue-component';
import IconNissan from '@itbpbg/lms-components/src/assets/svg/companies/icon-nissan-auto.svg?vue-component';
import IconStarbucks from '@itbpbg/lms-components/src/assets/svg/companies/icon-starbucks-auto.svg?vue-component';
import IconUPS from '@itbpbg/lms-components/src/assets/svg/companies/icon-ups-auto.svg?vue-component';
import IconVanguard from '@itbpbg/lms-components/src/assets/svg/companies/icon-vanguard-auto.svg?vue-component';
import IconVirginMedia from '@itbpbg/lms-components/src/assets/svg/companies/icon-virgin-media-auto.svg?vue-component';
import IconWalmart from '@itbpbg/lms-components/src/assets/svg/companies/icon-walmart-auto.svg?vue-component';
import Dropdown from '@itbpbg/lms-components/src/components/Dropdown';
import IconAssessment from '../assets/svg/corporate-training/icon-assessment.svg?vue-component';
import IconCustomization from '../assets/svg/corporate-training/icon-customization.svg?vue-component';
import IconTraining from '../assets/svg/corporate-training/icon-training.svg?vue-component';
import IconGraduation from '../assets/svg/corporate-training/icon-graduation.svg?vue-component';
import IconOnboardingCall from '../assets/svg/corporate-training/icon-onboarding-call.svg?vue-component';
import IconComprehensiveCompany from '../assets/svg/corporate-training/icon-comprehensive-company.svg?vue-component';
import IconCustomizedPlan from '../assets/svg/corporate-training/icon-customized-plan.svg?vue-component';
import IconCoaching from '../assets/svg/corporate-training/icon-coaching.svg?vue-component';
import IconWorkshops from '../assets/svg/corporate-training/icon-workshops.svg?vue-component';
import IconIndustryContent from '../assets/svg/corporate-training/icon-industry-content.svg?vue-component';
import IconQuote from '../assets/svg/corporate-training/icon-quote.svg?vue-component';
import IconCheck from '../assets/svg/corporate-training/icon-ct-check.svg?vue-component';
import IconCross from '../assets/svg/corporate-training/icon-ct-cross.svg?vue-component';
import IconArrow from '../assets/svg/corporate-training/icon-ct-arrow.svg?vue-component';
import IconTrustpilot from '../assets/svg/icon-trustpilot.svg?vue-component';
import IconStars from '../assets/svg/corporate-training/icon-stars-review.svg?vue-component';

export default {
  components: {
    SlidingAnimation,
    IconApple,
    IconBosch,
    IconDell,
    IconDeloitte,
    IconFedex,
    IconGoogle,
    IconHumana,
    IconIkea,
    IconLeowe,
    IconLindt,
    IconMeta,
    IconMicrosoft,
    IconNissan,
    IconStarbucks,
    IconUPS,
    IconVanguard,
    IconVirginMedia,
    IconWalmart,
    IconAssessment,
    IconCustomization,
    IconTraining,
    IconGraduation,
    IconOnboardingCall,
    IconComprehensiveCompany,
    IconCustomizedPlan,
    IconCoaching,
    IconWorkshops,
    IconIndustryContent,
    IconQuote,
    IconCheck,
    IconCross,
    IconArrow,
    SliderInfinite,
    IconTrustpilot,
    IconStars,
    Dropdown,
  },
  mixins: [global],
  async asyncData({
    $axios, route, $config, error,
  }) {
    const [page, stats] = await Promise.all([
      $axios.$get(`/pages/${route.fullPath}`).catch(() => false),
      $axios.$get('/stats/courses?reduced=1').catch(() => ({})),
    ]);

    if (!page) {
      return error({ title: 'Not found', statusCode: 404, message: 'Page not found' });
    }

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      page,
      stats,
    };
  },
  data() {
    return {
      pixelScript: '!function () {var reb2b = window.reb2b = window.reb2b || []; if (reb2b.invoked) return;reb2b.invoked = true;reb2b.methods = ["identify", "collect"]; reb2b.factory = function (method) {return function () {var args = Array.prototype.slice.call(arguments); args.unshift(method);reb2b.push(args);return reb2b;};}; for (var i = 0; i < reb2b.methods.length; i++) {var key = reb2b.methods[i];reb2b[key] = reb2b.factory(key);} reb2b.load = function (key) {var script = document.createElement("script");script.type = "text/javascript";script.async = true; script.src = "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" + key + "/5NRP9HQ7K4O1.js.gz"; var first = document.getElementsByTagName("script")[0]; first.parentNode.insertBefore(script, first);}; reb2b.SNIPPET_VERSION = "1.0.1";reb2b.load("5NRP9HQ7K4O1");}();',
      tableIsScrolled: false,
      chartsAnimated: false,
      selectedCourse: 1,
      selectedTrack: 1,
      testimonials: [
        {
          name: 'Veronika Konečná',
          work: 'Junior Financial Editor at',
          description: 'The courses cultivate a strategic mindset, preparing me for a future where data is at the heart of every financial and business decision.<br>The self-check tests and interactive exercises reinforced my understanding and boosted my confidence in applying these skills immediately to real projects.',
          image: 'veronika-konecna',
          logo: 'moneco',
          uniqueId: 'veronika-konecna',
        },
        {
          name: 'Yuvraj Shivaji Dhepe',
          work: 'Machine Learning Engineer at',
          description: 'I love the quality of projects at 365. I think they do make a difference and helped me to be more confident with coding and solving problems overall.<br><br>So yes, I’d say that 365 Data Science mentors have contributed to building my confidence and helping me apply my skills at work!',
          image: 'yuvraj-shivaji-dhepe',
          logo: 'perfacct',
          uniqueId: 'yuvraj-shivaji-dhepe',
        },
        {
          name: 'Lee McFarling',
          work: 'Data Analyst at',
          description: 'I’d say immediately after I joined, I was able to level up my Excel skills and my data visualization skills, and work on projects for my employer to help them track our client performance.',
          image: 'lee-mcfarling',
          logo: 'astreya',
          uniqueId: 'lee-mcfarling',
        },
        {
          name: 'Veronika Konečná',
          work: 'Junior Financial Editor at',
          description: 'The courses cultivate a strategic mindset, preparing me for a future where data is at the heart of every financial and business decision.<br>The self-check tests and interactive exercises reinforced my understanding and boosted my confidence in applying these skills immediately to real projects.',
          image: 'veronika-konecna',
          logo: 'moneco',
          uniqueId: 'veronika-konecna',
        },
        {
          name: 'Yuvraj Shivaji Dhepe',
          work: 'Machine Learning Engineer at',
          description: 'I love the quality of projects at 365. I think they do make a difference and helped me to be more confident with coding and solving problems overall.<br><br>So yes, I’d say that 365 Data Science mentors have contributed to building my confidence and helping me apply my skills at work!',
          image: 'yuvraj-shivaji-dhepe',
          logo: 'perfacct',
          uniqueId: 'yuvraj-shivaji-dhepe',
        },
        {
          name: 'Lee McFarling',
          work: 'Data Analyst at',
          description: 'I’d say immediately after I joined, I was able to level up my Excel skills and my data visualization skills, and work on projects for my employer to help them track our client performance.',
          image: 'lee-mcfarling',
          logo: 'astreya',
          uniqueId: 'lee-mcfarling',
        },
      ],
      instructors: [
        {
          name: 'Davis Balaba',
          slug: 'davis-balaba',
        },
        {
          name: 'Danielle Thé',
          slug: 'danielle-the',
        },
        {
          name: 'Bernard Marr',
          slug: 'bernard-marr',
        },
        {
          name: 'Anastasia Kuznetsova',
          slug: 'anastasia-kuznetsova',
        },
        {
          name: 'Jeff Lee',
          slug: 'jeff-li',
        },
        {
          name: 'Lauren Newbould',
          slug: 'lauren-newbould',
        },
        {
          name: 'Shashank Kalanithi',
          slug: 'shashank-kalanithi',
        },
        {
          name: 'Randy Rosseel',
          slug: 'randy-rosseel',
        },
        {
          name: 'Olivier Maugain',
          slug: 'olivier-maugain',
        },
        {
          name: 'Ken Jee',
          slug: 'ken-jee',
        },
        {
          name: 'Tina Huang',
          slug: 'tina-huang',
        },
        {
          name: 'Harpreet Sahota',
          slug: 'harpreet-sahota',
        },
        {
          name: 'Andrew Treadway',
          slug: 'andrew-treadway',
        },
        {
          name: 'Rahul Singh',
          slug: 'rahul-singh-47',
        },
        {
          name: 'Horia Mărgărit',
          slug: 'horia-margarit',
        },
      ],
      chartsData: [
        {
          percent: 94,
          color: '#3DAFB8',
          title: 'of employees <strong>stay longer</strong> when companies invest in their development',
          description: '*LinkedIn\'s Workplace Learning Report',
        },
        {
          percent: 218,
          color: '#DFB726',
          title: '<strong>higher income</strong> per employee at companies with comprehensive training',
          description: '*Forbes',
        },
        {
          percent: 59,
          color: '#3DAFB8',
          title: 'of employees believe that training directly <strong>improves</strong> their <strong>job performance</strong>',
          description: '*SurveyMonkey Research',
        },
      ],
      planSpecsMobile: {
        quickWin: [
          { name: 'Program duration: 2 weeks' },
          { name: 'Onboarding call' },
          { name: 'Self-paced learning' },
          { name: '1 Live workshop' },
          { name: 'Industry renowned instructors' },
          { name: '1-year access to 365 learning platform' },
          { name: 'Add-Ons', group: true },
          { name: 'Additional seats: $500/seat' },
        ],
        sustainableGrowth: [
          { name: 'Program duration: 12 weeks' },
          { name: 'Onboarding call' },
          { name: 'Self-paced learning' },
          { name: '12 Live workshops' },
          { name: 'Industry renowned instructors' },
          { name: 'Company assessment' },
          { name: 'Personalized learning program' },
          { name: '1:1 coaching & instructor sessions' },
          { name: 'Company-specific workshops' },
          { name: 'Industry-relevant content' },
          { name: '1-year access to 365 learning platform' },
          { name: 'Add-Ons', group: true },
          { name: 'Additional seats: $9,000 per seat (ask for volume discount)' },
          { name: 'Company coaching & consulting' },
          { name: 'Live training at company office' },
        ],
        expanded: {
          quickWin: false,
          sustainableGrowth: false,
        },
      },
      planSpecs: [
        {
          cols: [
            { name: 'Program duration' },
            { name: '2 weeks', class: '' },
            { name: '12 weeks', class: '' },
            { name: 'Custom', class: '' },
          ],
        },
        {
          cols: [
            { name: 'Onboarding call' },
            { check: true },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Self-paced learning' },
            { check: true },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Live sessions' },
            { name: '1 workshop' },
            { name: '12 workshop' },
            { name: 'Custom' },
          ],
        },
        {
          cols: [
            { name: 'Industry renowned instructors' },
            { check: true },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Company assessment' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Personalized learning program' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: '1:1 coaching & instructor sessions' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Company-specific workshops' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Industry-relevant content' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: '365 learning platform' },
            { name: '1-year access' },
            { name: '1-year access' },
            { name: 'Custom' },
          ],
        },
        {
          class: 'group',
          cols: [
            { name: 'Add-Ons' },
            { name: '' },
            { name: '' },
            { name: '' },
          ],
        },
        {
          cols: [
            { name: 'Additional seats' },
            { name: '$500 per seat' },
            { name: '$9,000 per seat<br>(ask for volume discount)' },
            { name: 'Custom' },
          ],
        },
        {
          cols: [
            { name: 'Company coaching & consulting' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
        {
          cols: [
            { name: 'Live training at company office' },
            { check: false },
            { check: true },
            { check: true },
          ],
        },
      ],
      planSpecsCards: [
        { name: 'Program duration', plan: ['free'] },
        { name: 'Onboarding call', plan: ['monthly', 'annual', 'business'] },
        { name: 'Self-paced learning', plan: ['monthly', 'annual', 'business'] },
        { name: 'Limited to 207 exercises', plan: ['free'] },
        { name: 'Limited to 5 free projects', plan: ['free', 'monthly'] },
        { name: 'All 23 projects', plan: ['annual', 'business'] },
        { name: 'Exams', plan: ['business'] },
        { name: 'Certificates of achievement', plan: ['business'] },
        { name: 'Downloadable resources', plan: ['all'] },
        { name: 'Social channels', plan: ['business'] },
        { name: 'Practice exams', plan: ['free', 'monthly', 'annual'] },
        { name: 'Resume builder', plan: ['free', 'monthly', 'annual'] },
        { name: '12 workshops', plan: ['free', 'monthly', 'annual'] },
        { name: 'Gamified features', plan: ['all'] },
        { name: 'Leaderboard', plan: ['all'], notChecked: ['free'] },
        { name: 'New content', plan: ['all'], notChecked: ['free'] },
        { name: 'Content updates', plan: ['all'], notChecked: ['free'] },
        { name: 'Structured career tracks', plan: ['all'], notChecked: ['free'] },
        { name: 'Custom learning path', plan: ['all'], notChecked: ['free'] },
        { name: 'Certification exams', plan: ['free', 'monthly', 'annual'], notChecked: ['free'] },
        { name: 'Certificates of achievement', plan: ['free', 'monthly', 'annual'], notChecked: ['free'] },
        { name: 'Resume feedback', plan: ['free', 'monthly', 'annual'], notChecked: ['free', 'monthly'] },
        { name: 'Portfolio advice', plan: ['free', 'monthly', 'annual'], notChecked: ['free', 'monthly'] },
        { name: 'Personalized support', plan: ['free', 'monthly', 'annual'], notChecked: ['free', 'monthly'] },
        { name: 'Priority onboarding', plan: ['business'] },
        { name: 'Access to talents', plan: ['business'] },
        { name: 'Admin dashboard', plan: ['business'] },
        { name: 'Task management', plan: ['business'] },
        { name: 'Advanced reporting', plan: ['business'] },
        { name: 'Data export', plan: ['business'] },
        { name: 'Dedicated support agent', plan: ['business'] },
      ],
      courses: {
        1: 'Data Strategy',
        2: 'AI Strategy',
        3: 'ChatGPT & Generative AI',
        4: 'Project Management',
        5: 'Data-driven Business Growth',
        6: 'Data Visualization in Python',
        7: 'The Machine Learning Process A-Z',
        8: 'Communication and Presentation Skills for Analysts',
        9: 'Building AI Applications in Practice',
        10: 'Mastering Key Performance Indicators',
      },
      tracks: {
        1: 'AI Engineering',
        2: 'Data Science',
        3: 'Data Engineering',
        4: 'AI for Business',
      },
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: '365 Data Science Corporate Training',
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  computed: {
    planSpecsMixed() {
      return this.planSpecs;
    },
    selectedCourseTitle() {
      if (!this.selectedCourse) return 'Data Strategy';

      return this.courses[this.selectedCourse] || 'Data Strategy';
    },
    selectedTrackTitle() {
      if (!this.selectedTrack) return 'AI Engineering';

      return this.tracks[this.selectedTrack] || 'AI Engineering';
    },
  },
  async mounted() {
    const tableIsScrolled = () => {
      const content = document.querySelector('.features .content');
      let condition = false;
      if (content) {
        const { top, bottom } = content.getBoundingClientRect();
        condition = top && top < 0 && bottom && (bottom - 199) > 0;
      }

      this.tableIsScrolled = this.$store.state.layout !== 'mobile' && condition;
    };

    const chartsAreScrolled = () => {
      const charts = document.querySelector('.section.charts .progress-holder');
      if (charts && !this.chartsAnimated) {
        const { top } = charts.getBoundingClientRect();

        const windowScrolledTop = window.scrollY || window.pageYOffset;
        const windowHeight = window.innerHeight;
        if (top && windowScrolledTop + windowHeight > top + 100) {
          this.chartsAnimated = true;

          for (let idx = 0; idx < this.chartsData.length; idx += 1) {
            const { percent } = this.chartsData[idx];
            if (percent > 100) {
              this.animateCircle(idx, 100);
              this.animateCircle(`${idx}0`, percent);
              this.animateCircle(`${idx}1`, 100);
              this.animateCircle(`${idx}2`, 18);
            } else {
              this.animateCircle(idx, percent, true);
            }
          }
        }
      }
    };

    tableIsScrolled();
    chartsAreScrolled();

    window.addEventListener('scroll', () => {
      tableIsScrolled();
      chartsAreScrolled();
    });
  },
  methods: {
    handleCourseChange(id) {
      this.selectedCourse = id;
    },
    handleTrackChange(id) {
      this.selectedTrack = id;
    },
    animateCircle(index, targetPercentage, basedDuration = false) {
      const progressCircle = document.getElementById(`progressCircle${index}`);
      const percentageText = document.getElementById(`percentageText${index}`);

      const radius = progressCircle.r.baseVal.value;
      const circumference = 2 * Math.PI * radius;

      const baseDuration = 2500;
      const maxPercentage = this.chartsData.map((d) => d.percent).reduce((a, b) => Math.max(a, b), 0);
      let targetDuration = baseDuration;

      if (basedDuration && targetPercentage !== maxPercentage) {
        targetDuration = (targetPercentage / maxPercentage) * baseDuration;
      }

      const animationDuration = targetDuration || baseDuration; // ms

      progressCircle.style.strokeDasharray = `${circumference}`;
      progressCircle.style.strokeDashoffset = `${circumference}`;

      function setProgress(percent) {
        const offset = circumference * (1 - percent / 100);
        progressCircle.style.strokeDashoffset = offset;
      }

      // Animate
      let start = null;
      function animate(timestamp) {
        if (!start) start = timestamp;
        const progress = Math.min((timestamp - start) / animationDuration, 1);
        const currentPercent = Math.floor(progress * targetPercentage);

        setProgress(currentPercent);
        if (percentageText) {
          percentageText.textContent = `${currentPercent}%`;
        }

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setProgress(targetPercentage);
          if (percentageText) {
            percentageText.textContent = `${targetPercentage}%`;
          }
        }
      }

      requestAnimationFrame(animate);
    },
    toggleSpecs(key) {
      this.planSpecsMobile.expanded[key] = !this.planSpecsMobile.expanded[key];
    },
  },
};
</script>

<style lang="scss" scoped>
.corporate-training-page {
  background: var(--main-dark);

  .hero-section {
    position: relative;
    min-height: 560px;
    background-image: url('../assets/images/corporate-training/hero-corporate-training.webp');
    image-rendering: -webkit-optimize-contrast;
    color: var(--true-white);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    background-color: var(--main-dark);
    margin-bottom: var(--spacing-36);
    padding-bottom: 16px;
    padding-top: 80px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: unset;

    &:after {
      content: '';
      width: 100%;
      height: 38px;
      background: var(--main-dark);
      position: absolute;
      bottom: -37px;
      left: 0;
    }

    .container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .head {
      max-width: 100%;
      width: 770px;
      padding-left: 15px;
      margin-top: 60px;
      height: 340px;
      display: flex;
      flex-direction: column;

      h1 {
        margin-bottom: 0;
        text-align: left;
        width: 95%;

        .highlight {
          color: var(--main-yellow);
          font-weight: 600;
          text-transform: uppercase;
        }

        .highlight-2 {
          color: var(--accent);
          font-weight: 600;
        }
      }

      p {
        text-align: left;
        font-size: 21px;
        color: var(--main-light);
        padding: 0;
        margin: 0;
        font-weight: 500;

        &:first-of-type  {
          margin: var(--spacing-24) 0 0;
          line-height: 140%;
        }
      }

      .wrapper {
        margin: auto 0;
        display: flex;
        align-items: center;

        .btn-primary {
          width: 300px;
          height: 58px;
          margin-top: var(--spacing-20);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
        }

        .reviews-wrapper {
          display: flex;
          align-items: center;
          position: relative;

          img {
            height: 36px;
            margin-right: 8px;
            margin-left: 24px;

            &.hover {
              height: 38px;
            }
          }

          .users.hover {
            position: absolute;
            left: -1px;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
          }

          span {
            font-size: 17px;
            font-weight: 500;
            line-height: 140%;
            color: var(--main-light-shade-4);
            transition: opacity 0.3s ease-in-out;
          }

          &:hover {
            .users.hover {
              opacity: 1;
            }

            span {
              color: var(--accent);
            }
          }
        }
      }
    }

    .logo-wrapper {
      width: 100%;
      overflow: hidden;

      p {
        font-size: 18px;
        font-weight: 500;
        line-height: 110%;
        margin-top: 0;
        margin-bottom: var(--spacing-12);
        text-align: left;
      }

      .companies-animation {
        display: flex;
        width: min-content;

        .row {
          flex-flow: nowrap;
        }

        svg {
          margin-right: 80px;
          width: 96px;
          height: 32px;
        }
      }
    }
  }

  .charts {
    h2 {
      width: 58%;
      margin: 0 auto 16px;

      .highlight-2 {
        color: var(--accent);
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    .progress {
      position: relative;
      width: 140px;
      height: 140px;
      margin: 0 auto;

      .progress-background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
      }

      .progress-circle {
        position: relative;
        z-index: 1;

        circle {
          transition: all 0.2s linear;
        }

        &.hidden {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0;
        }

        + .progress-circle {
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      .number {
        position: absolute;
        font-size: 27px;
        font-weight: 700;
        line-height: 30px;
        width: 100%;
        text-align: center;
        top: 50%;
        margin-top: -15px;
      }
    }

    .progress-holder {
      margin-top: 32px;

      .number {
        text-align: center;
      }
    }

    .titles {
      text-align: center;

      .title {
        font-size: 18px;
        line-height: 1.5;
        font-weight: 400;
        margin: 16px 0 12px;

        strong {
          font-weight: 700;
        }
      }

      .chart-description {
        font-size: 16px;
        line-height: 1.5;
        font-weight: 400;
        font-style: italic;
        color: var(--main-light-shade-4);
        margin-top: var(--spacing-8);
        margin-bottom: 0;
      }
    }
  }

  .section {
    background: var(--main-dark);
    color: var(--main-light);
    padding: 80px 0;

    h2 {
      text-align: center;

      .highlight {
        color: var(--main-yellow);
        font-weight: 600;
        text-transform: uppercase;
      }

      .highlight-2 {
        color: var(--accent);
        font-weight: 600;
      }

      .block {
        display: block;
      }
    }

    .description {
      text-align: center;
      font-size: 21px;
      width: 83%;
      line-height: 140%;
      margin: var(--spacing-12) auto var(--spacing-32);
      color: var(--main-light-shade-4);

      .highlight {
        color: var(--main-yellow);
        font-weight: 800;
      }
    }

    .box-wrapper {
      display: flex;
      align-items: flex-end;
      margin-bottom: 20px;

      .point-mobile {
        display: none;
      }

      .box {
        padding: 24px;
        border-radius: 20px;
        background: var(--main-dark-light-2);
        text-align: center;
        height: min-content;

        svg {
          width: 64px;
          height: 64px;
        }

        h3 {
          margin: 12px 0;

          .highlight {
            color: var(--main-yellow);
            font-weight: 700;
          }
        }

        p {
          font-size: 18px;
          line-height: 150%;

          &:first-of-type {
            color: var(--main-light-shade-4);
            font-weight: 600;
            margin-top: 0;
            margin-bottom: 12px;
          }

          &:last-of-type {
            margin: 0;
          }
        }
      }
    }

    .holder {
      text-align: center;
      position: relative;

      img  {
        padding-bottom: 84px;
      }

      .icon-graduation {
        position: absolute;
        width: 64px;
        height: 64px;
        left: calc(50% - 32px);
        top: 134px;
      }

      h3 {
        margin-bottom: 12px;
      }

      .btn-primary {
        width: 300px;
        height: 58px;
        margin-top: var(--spacing-20);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }
  }

  .reviews {
    .first-container {
      h3 {
        margin-bottom: 32px;
        text-align: center;

        .highlight-2 {
          color: var(--accent);
          font-weight: 600;
          text-transform: uppercase;
        }
      }

      .box {
        background: var(--main-dark-light-2);
        border-radius: 20px;
        padding: 32px;
        width: 670px;
        flex-direction: column;
        align-items: flex-start;

        .quote {
          width: 24px;
          height: 20px;
        }

        img {
          width: 140px;
          height: 140px;
          border: 2px solid var(--main-dark-light-4);
          border-radius: 10px;
        }

        .review-description {
          margin: 12px 0 24px;
          text-align: left;
          font-size: 16px;
          font-weight: 400;
          line-height: 150%;
          color: var(--main-light);
        }

        .people {
          display: flex;
          align-items: center;

          .text {
            margin-left: var(--spacing-16);

            .name {
              margin-top: 0;
              margin-bottom: 10px;
              font-size: 21px;
              font-weight: 500;
              line-height: 110%;
            }

            .work {
              margin: 0;
              font-size: 16px;
              line-height: 150%;
              font-weight: 400;

              svg {
                vertical-align: middle;
                margin-left: 4px;
              }
            }
          }
        }
      }

      ::v-deep .controls {
        display: none;
      }
    }

    .second-container {
     padding-left: 30px;
     padding-right: 30px;

      .wrapper {
        margin: 20px 5px 0;
        background: var(--main-dark-light-1);
        height: calc(100% - 20px);
        border-radius: 10px;

         &:after {
          content: '';
          position: absolute;
          width: unset;
          height: unset;
          border: unset;
          top: 0;
          left: 15px;
          right:15px;
          bottom: -20px;
          border-radius: 20px;
          padding: 2px;
          background: linear-gradient(to bottom, #56BFC7 0%, rgba(255, 255, 255, 0) 100%);
          -webkit-mask:
            linear-gradient(#FFF 0 0) content-box,
            linear-gradient(#FFF 0 0);
          mask:
            linear-gradient(#FFF 0 0) content-box,
            linear-gradient(#FFF 0 0);
          -webkit-mask-composite: destination-out;
          mask-composite: exclude;
          z-index: 0;
        }

        .holder {
          padding: 32px;
          text-align: left;
          position: relative;
          z-index: 1;

          a {
            color: var(--main-light);
          }

          .number {
            margin-top: 0;
            margin-bottom: var(--spacing-4);
            font-size: 40px;
            font-weight: 500;
            line-height: 110%;
          }

          .students {
            margin-top: 0;
            margin-bottom: 41px;
            font-size: 21px;
            font-weight: 500;
            line-height: 110%;
          }

          .stars {
            width: 170px;
            height: 32px;
            margin-bottom: 4px;
            margin-right: 100px;
          }

          .trustpilot {
            width: 113px;
            height: 27px;
            vertical-align: bottom;
          }

          .trust-wrap {
            margin-bottom: 41px;
          }

          span {
            font-size: 15px;
            font-weight: 500;
            line-height: 110%;

            .highlight-2 {
              color: var(--accent);
              font-weight: 600;
            }
          }

          .small-text {
            font-size: 21px;
            line-height: 140%;
            margin: 0;
          }
        }
      }
    }
  }

  .medals {
    padding-top: 32px;
    padding-bottom: 32px;
    text-align: center;
    display: flex;
    align-items: center;

    .image-holder {
      display: flex;

      img + img {
        margin-left: 12px;
      }
    }

    .gradient-line {
      height: 4px;
      width: 100%;
      background: linear-gradient(to right, #45c3d6, rgba(0, 0, 0, 0));
      margin-left: 32px;

      &.first {
        background: linear-gradient(to left, #45c3d6, rgba(0, 0, 0, 0));
        margin-left: 0;
        margin-right: 32px;
      }
    }
  }

  .tailored-for-you {
    h2 {
      margin-bottom: var(--spacing-12);
    }

    h3 {
      text-align: center;
      margin-bottom: 60px;
    }

    .wrapper {
      display: flex;
      flex-flow: wrap;
      row-gap: 60px;
      justify-content: center;

      .box {
        svg {
          width: 64px;
          height: 64px;
          margin-bottom: var(--spacing-12);
        }

        .title {
          font-size: 24px;
          font-weight: 500;
          line-height: 110%;
          margin: 0 0 var(--spacing-16);
        }

        .small-description {
          font-size: 18px;
          line-height: 150%;
          color: var(--main-light-shade-4);
          margin: 0;
        }
      }
    }
  }

  .instructors {
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;

    .instructors-animation {
      width: min-content;
      display: flex;

      > div {
        display: flex;

        > div {
          display: flex;

          > * {
            padding: 0 15px;
          }
        }
      }

      a {
        display: block;
      }
    }

    .instructors-slider {
      .animation-container {
        display: flex;
        column-gap: 25px;

        img {
          border-radius: 17px;
        }

        .instructor-mobile {
          display: none;
        }
      }
    }

    h2 {
      width: 66%;
      margin: 0 auto var(--spacing-12);

      .highlight-2 {
        color: var(--accent);
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }

  .features {
    .features-title {
      display: flex;
      align-items: flex-end;
      font-size: 24px;
      font-weight: 500;
      padding-bottom: 12px;
    }

    .h3 {
      text-align: center;
      margin-bottom: var(--spacing-16);
    }

    .subtitle {
      text-align: center;
      color: var(--main-dark-light-4);
    }

    .content {
      margin-top: 60px;
      position: relative;

      .row {
        .col + .col {
          color: var(--main-dark);

          .col-bg {
            position: relative;
            // z-index: 1;
            padding: 11px 28px;
          }

          &:before {
            content: '';
            top: 0;
            bottom: 0;
            left: 15px;
            right: 15px;
            background-color: var(--main-light);
            position: absolute;
            z-index: 0;
          }
        }

        .col:nth-child(3) {
          .col-bg {
            padding-left: 16px;
            padding-right: 16px;
          }

          &:before {
            left: 7px;
            right: 7px;
          }
        }

        &.sticky + .row .col + .col {
          .col-bg {
            padding-top: 28px;
          }

          &:before {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
          }
        }

        &:last-child .col {
          &:nth-child(3):before {
            bottom: -16px;
          }

          + .col:before {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
        }

        &.row-selector {
          text-align: center;

          .content-selector {
            line-height: 21px;

            ::v-deep .dropdown {
              width: 100%;
              margin-top: 4px;
              font-weight: 600;
              text-align: left;

              .list-head {
                color: var(--accent-shade-2);
                padding: 6px 20px 6px 16px;
                outline: 1px solid var(--main-light-shade-4);
                border-radius: 5px;
              }

              &.open {
                .list-head {
                  border-bottom-left-radius: 0;
                  border-bottom-right-radius: 0;
                }
              }

              .list {
                outline: 1px solid var(--main-light-shade-4);
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
                max-height: 223px;

                li {
                  text-align: left;

                  div {
                    margin-left: var(--spacing-16);

                    .custom-checkbox + label {
                      display: inline-block;
                      line-height: 1.3;

                      span {
                        overflow: visible;
                        white-space: normal;
                        text-overflow: clip;
                      }
                    }

                    label {
                      padding-top: 12px;
                      padding-bottom: 10px;

                      span {
                        padding-left: 0;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        &.sticky {
          position: fixed;
          top: 80px;
          z-index: 2;
          width: calc(var(--container-width) + var(--gutter));
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px 0 rgba(0, 12, 31, 0.25);

          &:not(.scrolled) {
            opacity: 0;
            visibility: hidden;
            transform: translateY(-100%);
          }

          .title {
            font-size: 16px;
          }

          .price {
            margin: 0 0 12px;
          }

          .price,
          .price .discount-price {
            height: auto;
            font-size: 18px;
          }

          .btn-primary {
            margin-bottom: 0;
            height: 40px;
            padding: 11px 0;
          }
        }
      }

      .blue {
        display: flex;
        align-items: center;
        color: var(--accent);
        font-weight: 700;
      }

      .title {
        font-size: 21px;
        line-height: 23px;
        font-weight: 500;
        color: var(--main-dark-light-2);
      }

      .billed {
        font-size: 14px;
        display: block;
        color: var(--main-dark-light-4);
        margin-top: 8px;
        margin-bottom: 12px;
      }

      .price {
        margin: 8px 0 12px;
        max-width: 100%;
        height: 55px;
        line-height: normal;

        .old-price {
          font-size: 14px;
          font-weight: 500;
          color: var(--main-dark-light-3);
          position: relative;

          &:not(.empty):after {
            content: '';
            position: absolute;
            width: 100%;
            height: 1px;
            left: 0;
            top: 50%;
            background-color: var(--main-dark-light-3);
          }
        }

        .discount-price {
          font-size: 32px;
          font-weight: 500;
          display: block;

          .month {
            font-weight: 400;
          }
        }

        .month {
          font-size: 16px;
          font-weight: 500;
        }
      }

      .btn-primary,
      .btn-primary-yellow {
        width: 100%;
        height: 58px;
        padding: 20px 0;
        margin-bottom: 18px;
        font-size: 16px;
      }

      .sustainable-growth {
        position: relative;
        padding-top: 24px;
        margin-top: -24px;

        .title {
          color: var(--accent-shade-2);
        }

        .label {
          position: absolute;
          left: 50%;
          margin-left: -70px;
          width: 140px;
          height: 28px;
          line-height: 28px;
          background-color: var(--main-yellow);
          color: var(--main-dark);
          top: -16px;
          border-radius: 3px;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }

      .enterprise-custom {
        .price {
          display: flex;
          align-items: center;

          .discount-price {
            font-size: 18px;
          }
        }
      }

      .group {
        .col {
          &:first-child {
            font-size: 24px;
            font-weight: 500;
            padding-top: 36px;
            padding-bottom: 12px;
            display: flex;
            align-items: flex-end;
          }
        }
      }

      .row.sticky + .row ~ .row:before {
        content: '';
        margin-left: 15px;
        width: calc(100% - 30px);
        height: 1px;
        background-color: var(--main-light-shade-4);
      }

      .row.spec {
        color: var(--main-light-shade-2);
        font-weight: 400;

        .col {
          min-height: 42px;
          display: flex;
          align-items: center;
        }

        .col + .col {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 14px;
          font-weight: 400;

          &.check {
            color: var(--accent-shade-2);
          }
        }
      }
    }

    .features-footer {
      color: var(--main-dark-light-4);
      font-size: 18px;
      font-weight: 400;
      text-align: center;

      .vat {
        margin: var(--spacing-16) 0 0;
      }
    }
  }

  .banner {
    padding-top: 0;
    padding-bottom: 80px;

    .banner-holder {
      height: 512px;
      background-image: url('../assets/images/corporate-training/corporate-training-banner.webp');
      border-radius: 10px;
      background-size: cover;
      background-position: bottom;
      background-repeat: no-repeat;
      position: relative;
      padding: 24px;

      &:after {
        content: '';
        position: absolute;
        width: unset;
        height: unset;
        border: unset;
        top: 24px;
        left: 24px;
        right: 24px;
        bottom: 24px;
        border-radius: 10px;
        padding: 1px;
        background: linear-gradient(to bottom, #FFFFFF 0%, rgba(255, 255, 255, 0) 80%);
        -webkit-mask:
          linear-gradient(#FFF 0 0) content-box,
          linear-gradient(#FFF 0 0);
        mask:
          linear-gradient(#FFF 0 0) content-box,
          linear-gradient(#FFF 0 0);
        -webkit-mask-composite: destination-out;
        mask-composite: exclude;
        z-index: 0;
      }

      > * {
        position: relative;
        z-index: 1;
      }

      .highlight-2 {
        color: var(--accent);
        font-weight: 600;
        text-transform: uppercase;
      }

      h2 {
        margin-top: 56px;
        margin-bottom: var(--spacing-12);
      }

      .description {
        margin-top: 0;
        margin-bottom: var(--spacing-40);
      }

      .btn-primary {
        width: 300px;
        height: 58px;
        padding-left: 0;
        padding-right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }
  }
}

@include bp($bp-laptop) {
  .corporate-training-page {
    .hero-section {
      .head {
        p {
          width: 90%;
        }

        h1 {
          width: 90%;
        }

        .wrapper .btn-primary {
          width: 225px;
        }
      }
    }

    .section {
      .holder {
        .points {
          width: 810px;
        }

        .icon-graduation {
          top: 120px;
        }

        .btn-primary {
          width: 225px;
        }
      }
    }

    .tailored-for-you {
      .wrapper {
        .box {
          .title {
            font-size: 21px;
          }
        }
      }
    }

    .reviews .first-container .box {
      width: 565px;

      .review-description {
        width: 100%;
      }
    }

    .instructors {
      img.instructor-desktop {
        width: 178px;
      }
    }

    .features .content {
      .sustainable-growth {
        padding-top: 13px;
        margin-top: -13px;
      }

      .row:last-child .col:nth-child(3):before {
        bottom: -13px;
      }

      .title {
        font-size: 18px;
      }

      .row-selector {
        font-size: 14px;
      }
    }

    .banner {
      .banner-holder {
        .description {
          width: 90%;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .corporate-training-page {
    .hero-section {
      min-height: 708px;
      padding-top: 68px;
      background-image: url('../assets/images/corporate-training/hero-corporate-training-mobile.webp');
      background-position: top;

      .container {
        margin-left: 0;

        .row {
          margin: 0;
        }

        .head {
          width: unset;
          height: unset;
          padding-left: 0;

          h1 {
            text-align: center;
            margin: 0 auto;
            font-size: 40px;
            width: unset;
          }

          p {
            text-align: center;
          }

          .wrapper {
            flex-direction: column;
            margin-bottom: 24px;

            .btn-primary {
              width: 100%;
              margin: 24px 0;
            }
          }
        }
      }

      .logo-wrapper p {
        margin-left: 0;
        text-align: center;
      }
    }

    .charts {
      h2 {
        width: 85%;
      }

      .progress-holder {
        margin-bottom: 24px;

        .number {
          font-size: 24px;
          line-height: 28px;
        }

        .col-4:last-of-type {
          .titles {
            .chart-description {
              margin-bottom: 0;
            }
          }
        }
      }

      .titles {
        .title {
          font-size: 18px;
          line-height: 1.5;
          font-weight: 400;
          margin: 16px 0 12px;

          strong {
            font-weight: 700;
          }
        }

        .chart-description {
          margin-bottom: 30px;
        }
      }
    }

    .section {
      padding: 80px 24px;

      &.table {
        padding: 80px 0;
      }

      .points {
        display: none;
      }

      h2 {
        font-size: 32px;
      }

      .box-wrapper {
        justify-content: center;
        margin-bottom: 92px;

        .point-mobile {
          display: block;

          &.end {
            transform: rotate(180deg);
          }
        }
      }

      .holder {
        .icon-graduation {
          top: -72px;
        }

        .btn-primary {
          width: 100%;
        }
      }

      .description {
        width: 100%;
      }
    }

    .reviews {
      .first-container {
        margin-bottom: 60px;

        .box {
          width: 100%;

          .people {
            flex-direction: column;
            align-items: flex-start;

            .text {
              margin-left: 0;
              margin-top: 16px;
            }
          }
        }
      }
    }

    .medals {
      justify-content: center;

      .image-holder {
        flex-direction: column;
        margin-left: 51px;
        margin-right: 51px;

        img + img {
          margin-top: 12px;
          margin-left: 0;
        }
      }

      .gradient-line {
        margin: 0;
        position: relative;
        background: linear-gradient(to top, #45c3d6, rgba(0, 0, 0, 0));
        width: 4px;
        height: 119vw;

        &.first {
          background: linear-gradient(to top, #45c3d6, rgba(0, 0, 0, 0));
          margin-left: 0;
          margin-right: 0;
        }
      }
    }

    .tailored-for-you {
      h3 {
        font-size: 32px;
      }

      .wrapper {
        text-align: center;
        row-gap: 30px;

        .box {
          svg {
            width: 52px;
            height: 52px;
            margin-bottom: 8px;
          }

          .title {
            font-size: 21px;
          }
        }
      }
    }

    .instructors {
      h2 {
        width: 95%;
      }

      .instructors-slider .animation-container {
        .instructor-mobile {
          display: block;
        }

        .instructor-desktop {
          display: none;
        }
      }
    }

    .features {
      .content {
        .sustainable-growth {
          padding-top: 0;
          margin-top: 0;
        }

        .enterprise-custom {
          .price {
            margin: 16px 0 0;
            height: auto;
          }

          .billed {
            display: none;
          }

          .mobile-text {
            display: block;
            margin: 16px 0;
          }
        }

        .title {
          font-size: 18px;
        }

        .quick-win ~ .col {
          margin-top: 30px;
        }

        .row {
          .col {
            &:first-child {
              display: none !important;
            }

            &:nth-child(3):before {
              left: 15px;
              right: 15px;
            }

            + .col .col-bg {
              padding-bottom: 0;
              padding-left: 28px;
              padding-right: 28px;
            }
          }

          &.sticky + .row {
            ~ .row {
              display: none;
            }

            .col + .col:before {
              border-radius: 10px;
            }
          }

          + .row:before {
            display: none;
          }

          .col + .col.enterprise-custom .col-bg {
            padding-bottom: 14px;
          }
        }
      }

      .specs-mobile {
        padding-bottom: 28px;

        .button-expand {
          display: flex;
          align-items: center;
          line-height: 20px;
          color: var(--main-light-shade-4);
          font-size: 18px;
          cursor: pointer;

          svg {
            flex: 0 0 auto;
            margin-left: 4px;
            transition: all 0.6s ease;
          }
        }

        &.expanded {
          .button-expand {
            svg {
              transform: rotate(180deg);
            }
          }

          .specs-mobile-holder {
            max-height: 900px;
          }
        }

        .specs-mobile-holder {
          overflow: hidden;
          max-height: 0;
          transition: all 0.6s ease;

          .specs-mobile-group {
            font-size: 18px;
            margin-bottom: 20px;
            font-weight: 500;

            &:first-of-type {
              padding-top: 32px;
            }

            ~ .specs-mobile-group {
              margin-top: 36px;
            }
          }

          .specs-mobile-spec {
            &:not(:has(select)) {
              display: flex;
              align-items: center;
              line-height: 24px;
            }

            svg {
              margin-right: 12px;
              flex: 0 0 auto;
            }

            select {
              height: 40px;
              padding-top: 4px;
              padding-bottom: 4px;
              margin-top: 4px;
            }

            + .specs-mobile-spec {
              margin-top: 16px;
            }

            &.first {
              display: block;

              ::v-deep .dropdown {
                width: calc(100% - 2px);
                margin: 0 auto;
                margin-top: 4px;
                font-weight: 600;

                .list-head {
                  color: var(--accent-shade-2);
                  padding: 6px 20px 6px 16px;
                  outline: 1px solid var(--main-light-shade-4);
                  border-radius: 5px;
                }

                &.open {
                  .list-head {
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                  }
                }

                .list {
                  outline: 1px solid var(--main-light-shade-4);
                  border-bottom-left-radius: 5px;
                  border-bottom-right-radius: 5px;
                  max-height: 223px;

                  li {
                    text-align: left;

                    div {
                      margin-left: var(--spacing-16);

                      label {
                        padding-top: 8px;
                        padding-bottom: 8px;

                        span {
                          padding-left: 0;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .banner {
      .banner-holder {
        padding: 16px;
        height: 669px;
        background-image: url('../assets/images/corporate-training/corporate-training-banner-mobile.webp');

        &:after {
          top: 16px;
          left: 16px;
          right: 16px;
          bottom: 16px;
        }

        h2 {
          margin: 44px 8px var(--spacing-12);
        }

        .description {
          width: auto;
          margin-left: 8px;
          margin-right: 8px;
        }

        .btn-primary {
          max-width: 335px;
          width: 100%;
        }
      }
    }
  }
}
</style>
